import { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Flex, Loading, Text } from "@paguelofacil/pf-components";
import { toast } from "react-toastify";

import { useGetSubAccountInfo } from "../../hooks/useGetSubAccountInfo";
import { language, languageDefault } from "../../services/utils/Language";
import useStore from "../../services/store/useStore";

import VerticalTimeline from "./Timeline";

import "../../assets/scss/containers.scss";

const ValidateStatusKyc = ({ handleStepVerificated, platform }) => {
    const { user } = useStore(state => state);

    const { kycData, isLoadingFetch, refetch } = useGetSubAccountInfo(platform, user);
    const kycStatus = kycData ? kycData?.kycStatus : "PENDING";
    const status = kycData ? kycData?.status : "INITIAL";

    const [isDisabledButtonValidation, setIsDisabledButtonValidation] = useState(false);
    const [canShowTimelime, setCanShowTimelime] = useState(false);

    const onInitValidationKyc = async () => {
        const responseKyc = await refetch();
        console.log("responseKycresponseKyc", responseKyc);

        if (responseKyc?.kycStatus === "VERIFIED" || responseKyc?.status === "PASS") {
            toast.success("La información de la cuenta ya ha sido verificada");
            return;
        }
        if (
            responseKyc &&
            responseKyc?.cryptoSubAccount &&
            responseKyc?.cryptoSubAccount?.kycInfo &&
            responseKyc?.cryptoSubAccount?.kycInfo?.pageUrl
        ) {
            window.open(responseKyc?.cryptoSubAccount?.kycInfo?.pageUrl, "_blank");
            setIsDisabledButtonValidation(true);

            setTimeout(() => {
                setIsDisabledButtonValidation(false);
                setCanShowTimelime(true);
            }, 10000);

            return;
        }

        toast.error("La información de la cuenta no está disponible");
    };

    console.log("kycData en validacion status kyc", kycData);

    return (
        <Loading isLoading={isLoadingFetch}>
            {kycStatus === "PENDING" && status === "INITIAL" && !canShowTimelime ? (
                <Flex direction="column" style={{ marginTop: "1rem" }} gap="1.5rem">
                    <Text variant="body5" weight="medium">
                        <FormattedMessage
                            id={language.kyc_cryptofacil_title}
                            defaultMessage={languageDefault.kyc_cryptofacil_title}
                        />
                    </Text>
                    <Text variant="body6" weight="regular">
                        <FormattedMessage
                            id={language.kyc_cryptofacil_description}
                            defaultMessage={languageDefault.kyc_cryptofacil_description}
                        />
                    </Text>
                    <Flex align="center" justify="flex-end">
                        <Button
                            className="button-primary-cf"
                            size="md"
                            widthAuto
                            variant="primary"
                            type="button"
                            disabled={isDisabledButtonValidation}
                            handleClick={onInitValidationKyc}
                        >
                            <FormattedMessage
                                id={language.init_validation}
                                defaultMessage={languageDefault.init_validation}
                            />
                        </Button>
                    </Flex>
                </Flex>
            ) : kycStatus === "VERIFIED" || status === "PASS" ? (
                handleStepVerificated()
            ) : (
                <Flex direction="column" align="start" justify="start" style={{ marginTop: "1rem" }}>
                    <Text variant="body5" weight="medium" style={{ alignSelf: "center" }}>
                        <FormattedMessage
                            id={language.kyc_cryptofacil_title}
                            defaultMessage={languageDefault.kyc_cryptofacil_title}
                        />
                    </Text>

                    <VerticalTimeline data={{ kycStatus, status }} />

                    <Flex align="center" justify="flex-end">
                        <Button
                            className="button-primary-cf"
                            size="md"
                            widthAuto
                            variant="primary"
                            type="button"
                            handleClick={onInitValidationKyc}
                        >
                            <FormattedMessage
                                id={
                                    status === "REJECT" || status === "ERROR_KYC" || status === "REFUSED"
                                        ? "retry_request"
                                        : "update"
                                }
                                defaultMessage={
                                    status === "REJECT" || status === "ERROR_KYC" || status === "REFUSED"
                                        ? "Reintentar"
                                        : "Actualizar"
                                }
                            />
                        </Button>
                    </Flex>
                </Flex>
            )}
        </Loading>
    );
};

export default ValidateStatusKyc;
